const styles = theme => {
    const appBarHeight = theme.spacing(7)
    return {
        content: {
            flexGrow: 1,
            height: `calc(100% - ${appBarHeight})`,
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(0),
            paddingTop: theme.spacing(0),
            transition: theme.transitions.create('margin', {
                duration: theme.transitions.duration.leavingScreen,
                easing: theme.transitions.easing.sharp,
            })
        }
    }
}

export default styles
